<div class="white-wrap-admin">
  <div *ngIf="stepActive < 5">
    <div class="back-link-outer">
      <div class="back-link-outer mb-3 d-flex">
        <a class="back-link" role="button" (click)="gotoAuctionListing()">
          <img alt="back-icon" src="../assets/images/back.svg" /> back
        </a>
      </div>
    </div>

    <h1 class="white-wrap-hdg mb-3">
      {{ editMode ? "Edit" : "Create New" }} Auction
      {{ auctionCode ? " - " + auctionCode : "" }}
    </h1>

    <ng-container *ngIf="needSteps">
      <div class="top-steps-wrap">
        <div class="mobile-step-accordion d-md-none" role="button" (click)="showSteps = !showSteps">
          <p class="step-accr-current">Step {{ stepActive }} Of 4</p>
          <p class="step-accr-active">Basic Details</p>
          <img alt="arrow-icon" src="../assets/images/dropdown-arrow.svg" [ngClass]="{ active: showSteps }" />
        </div>

        <ul class="auction-stepper mobile-auction-stepper" [ngClass]="{ active: showSteps }">
          <li [ngClass]="{
              'active-step': stepActive == 1,
              'completed-step': stepActive > 1
            }" role="button" (click)="goToCurrentStep(1)">
            <span class="step-num"> <span class="d-md-none">0</span>1 </span>
            <span class="step-name">Basic Details</span>
          </li>

          <li [ngClass]="{
              'active-step': stepActive == 2,
              'completed-step': stepActive > 2
            }" role="button" (click)="goToCurrentStep(2)">
            <span class="step-num"> <span class="d-md-none">0</span>2</span>
            <span class="step-name">Manage Gallery</span>
          </li>

          <li [ngClass]="{
              'active-step': stepActive == 3,
              'completed-step': stepActive > 3
            }" role="button" (click)="goToCurrentStep(3)">
            <span class="step-num"> <span class="d-md-none">0</span>3 </span>
            <span class="step-name">Display Details</span>
          </li>

          <li [ngClass]="{ 'active-step': stepActive == 4 }" role="button" (click)="goToCurrentStep(4)">
            <span class="step-num"> <span class="d-md-none">0</span>4 </span>
            <span class="step-name">Locations & Contacts</span>
          </li>
        </ul>
      </div>
    </ng-container>

    <div class="steeper-data">
      <div class="step-parts" *ngIf="stepActive == 1">
        <app-add-auction-step1 (goToStep)="setActiveStep($event)" (newAuctionId)="setNewAuctionId($event)"
          (newAuctionCode)="setNewAuctionCode($event)" [auctionId]="auctionId" [isEditMode]="editMode"
          (getAuctionStatus)="getAuctionStatus($event)" (otherStepsNeeded)="needSteps = $event">
        </app-add-auction-step1>
      </div>

      <ng-container *ngIf="needSteps">
        <div class="step-parts" *ngIf="stepActive == 2">
          <app-add-auction-step2 (goToStep)="setActiveStep($event)" [auctionId]="auctionId"
            [auctionStatus]="auctionStatus" [isEditMode]="editMode">
          </app-add-auction-step2>
        </div>

        <div class="step-parts" *ngIf="stepActive == 3">
          <app-add-auction-step3 (goToStep)="setActiveStep($event)" [auctionId]="auctionId"
            [auctionStatus]="auctionStatus" [isEditMode]="editMode">
          </app-add-auction-step3>
        </div>

        <div class="step-parts" *ngIf="stepActive == 4">
          <app-add-auction-step4 (goToStep)="setActiveStep($event)" [auctionId]="auctionId"
            [auctionStatus]="auctionStatus" [isEditMode]="editMode">
          </app-add-auction-step4>
        </div>
      </ng-container>
    </div>
  </div>

  <div class="mx-auto text-center" *ngIf="stepActive == 5">
    <div class="auction-success">
      <img alt="success-icon" src="../assets/images/auction-success.svg" />
      <h1 class="success-msg">
        Auction {{ statusString | titlecase }} Successfully!
      </h1>
      <p class="dtl">
        Your auction has been {{ statusString }} and is under review.
      </p>

      <ng-container *ngIf="needSteps">
        <p class="dtl">
          Here is the public link for this auction.
          <a (click)="openLink(websiteUrl + auctionCode)" style="cursor: pointer; color: #8d1231;
          text-decoration: underline;
          cursor: pointer;">Click to view auction detail</a>
          <a (click)="openLotsLink(websiteUrl + auctionCode + '/lots')" style="cursor: pointer; color: #8d1231;
         text-decoration: underline;
         cursor: pointer;">Click to view lot catalog</a>
          <button class="btn btn-white-border mt-4 font-15" role="button" (click)="copyText(websiteUrl + auctionCode)">
            Copy to clipboard
          </button>
        </p>
      </ng-container>

      <button class="btn btn-colored" role="button" (click)="gotoAuctionListing()">
        Take Me to Auctions Page
      </button>
    </div>
  </div>
</div>
